import { Injectable } from '@angular/core';

const MAGNIFIER_SIZE = 90;

@Injectable()
export class Eyedropper {
    active = false;

    private image: CanvasRenderingContext2D | null;
    private color: string;
    private callback: (color: string) => void;
    private magnifierCanvas: any;
    private magnifierPixelCanvas: any;
    private magnifierCtx: any;
    private background: HTMLElement;

    start(callback: (color: string) => void): void {
        const Bannerflow = (window as any).Bannerflow;

        if (Bannerflow) {
            this.callback = callback;

            Bannerflow.captureScreen(data => {
                const image = new Image();
                image.onload = (): void => {
                    this.active = true;

                    const canvas = document.createElement('canvas');
                    canvas.width = image.width / window.devicePixelRatio;
                    canvas.height = image.height / window.devicePixelRatio;

                    this.image = canvas.getContext('2d')!;
                    this.image.drawImage(
                        image,
                        0,
                        0,
                        image.width / window.devicePixelRatio,
                        image.height / window.devicePixelRatio
                    );

                    this.createDOM();

                    window.addEventListener('mousemove', this.mouseMove);
                };
                image.src = data;
            });
        }
    }

    private createDOM(): void {
        this.magnifierCanvas = document.createElement('canvas');
        this.magnifierCanvas.width = MAGNIFIER_SIZE;
        this.magnifierCanvas.height = MAGNIFIER_SIZE;
        this.magnifierCanvas.style.width = `${MAGNIFIER_SIZE}px`;
        this.magnifierCanvas.style.height = `${MAGNIFIER_SIZE}px`;
        this.magnifierCanvas.style.position = 'absolute';
        this.magnifierCanvas.style.borderRadius = '100%';
        this.magnifierCanvas.style.border = '3px solid white';
        this.magnifierCanvas.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.25)';
        this.magnifierCtx = this.magnifierCanvas.getContext('2d');
        this.magnifierCtx.msImageSmoothingEnabled = false;
        this.magnifierCtx.mozImageSmoothingEnabled = false;
        this.magnifierCtx.webkitImageSmoothingEnabled = false;
        this.magnifierCtx.imageSmoothingEnabled = false;

        this.magnifierPixelCanvas = document.createElement('canvas') as any;
        this.magnifierPixelCanvas.width = 11;
        this.magnifierPixelCanvas.height = 11;

        document.body.appendChild(this.magnifierCanvas);

        this.background = document.createElement('div');
        this.background.style.width = '100%';
        this.background.style.height = '100%';
        this.background.style.position = 'absolute';
        this.background.style.top = '0';
        this.background.style.left = '0';
        this.background.style.zIndex = '1000';

        document.body.appendChild(this.background);

        this.background.addEventListener('mousedown', this.done);
    }

    private destroyDOM(): void {
        this.magnifierCanvas.parentNode!.removeChild(this.magnifierCanvas);
        this.background.parentNode!.removeChild(this.background);
    }

    private done = ((event: MouseEvent): boolean => {
        this.callback(this.color);
        window.removeEventListener('mousemove', this.mouseMove);
        this.background.removeEventListener('mousedown', this.done);

        this.destroyDOM();

        this.active = false;

        event.preventDefault();
        event.stopPropagation();

        return false;
    }).bind(this);

    private getColorAtCoordinate(x: number, y: number): string {
        const rgb = this.image!.getImageData(x, y, 1, 1);
        return `rgb(${rgb.data[0]}, ${rgb.data[1]}, ${rgb.data[2]})`;
    }

    private drawMagnifier(x: number, y: number): void {
        const imageData = this.image!.getImageData(x - 4, y - 4, 11, 11);

        this.magnifierCanvas.style.left = `${x + 5}px`;
        this.magnifierCanvas.style.top = `${y + 5}px`;

        this.magnifierPixelCanvas.getContext('2d').putImageData(imageData, 0, 0);

        this.magnifierCtx.clearRect(0, 0, MAGNIFIER_SIZE, MAGNIFIER_SIZE);
        this.magnifierCtx.scale(10, 10);
        this.magnifierCtx.drawImage(this.magnifierPixelCanvas, 0, 0);
        this.magnifierCtx.scale(0.1, 0.1);
        this.magnifierCtx.beginPath();
        this.magnifierCtx.moveTo(MAGNIFIER_SIZE / 2 - 5, MAGNIFIER_SIZE / 2 - 5);
        this.magnifierCtx.lineTo(MAGNIFIER_SIZE / 2 + 5, MAGNIFIER_SIZE / 2 - 5);
        this.magnifierCtx.lineTo(MAGNIFIER_SIZE / 2 + 5, MAGNIFIER_SIZE / 2 + 5);
        this.magnifierCtx.lineTo(MAGNIFIER_SIZE / 2 - 5, MAGNIFIER_SIZE / 2 + 5);
        this.magnifierCtx.closePath();
        this.magnifierCtx.strokeStyle = '#000000';
        this.magnifierCtx.lineWidth = 1;
        this.magnifierCtx.stroke();
    }

    private mouseMove = ((event: MouseEvent): void => {
        this.color = this.getColorAtCoordinate(event.clientX, event.clientY);
        this.drawMagnifier(event.clientX, event.clientY);
    }).bind(this);
}
